class FormBridgeClient {
  _isReady: boolean;
  constructor() {}

  onReady(callback) {
    // 向父元素发起 'client_ready' 的通知
    window.parent.postMessage(
      {
        msg: "client_ready",
      },
      "*"
    );
    callback();
    console.log("[client]: client is ready...");
    this._isReady = true;
  }

  // /**
  //  * 关闭 iframe
  //  */
  close() {
    window.parent.postMessage(
      {
        msg: "close_dialog",
      },
      "*"
    );
  }

  /**
   * 接收数据
   */
  onReceiveData(callback) {
    window.addEventListener(
      "message",
      ({ data }) => {
        console.log("[client]: 收到 master 的数据", data);
        callback(data);
      },
      false
    );
  }

  /**
   * 提交数据
   */
  postData(data) {
    console.log("[client]: 向 master 发送数据");
    window.parent.postMessage(
      {
        msg: "client_post_data",
        data,
      },
      "*"
    );
  }
}

export default FormBridgeClient;
